import type { Vehicle } from '../../data/vehicles'

/* The shape the mega menu's slider reads: one company, its cars. Kept out
   of the component file so the component exports nothing but itself. */

export type BrandGroup = {
  brand: string
  count: number
  cars: Vehicle[]
}

/** Groups the floor by company, featured cars first, four to a slide. */
export function groupByBrand(vehicles: Vehicle[], brands: string[]): BrandGroup[] {
  return brands.map((brand) => {
    const cars = vehicles
      .filter((vehicle) => vehicle.brand === brand)
      .sort((a, b) => Number(b.featured ?? false) - Number(a.featured ?? false))
    return { brand, count: cars.length, cars: cars.slice(0, 4) }
  })
}
